import { render, staticRenderFns } from "./ChatSidebarMessageThreadItem.vue?vue&type=template&id=f499c538&scoped=true&"
import script from "./ChatSidebarMessageThreadItem.vue?vue&type=script&lang=js&"
export * from "./ChatSidebarMessageThreadItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatSidebarMessageThreadItem.vue?vue&type=style&index=0&id=f499c538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f499c538",
  null
  
)

export default component.exports